import React, { useEffect } from "react";
import { getVideoSrcProvider } from "../../utils/manipulation";
import "plyr-react/plyr.css";
import "plyr/dist/plyr.css";

export default function VideoPlayer({ data, isAutoplay }) {
  const isMux = data.MuxVideo?.playbackId ? true : false;
  const videoSrcProvider = getVideoSrcProvider(data);
  const isLoom = videoSrcProvider?.provider === "loom";

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const Plyr = require("plyr");
      Array.from(document.querySelectorAll(".js-player")).map(
        (p) =>
          new Plyr(
            p,
            isAutoplay && {
              volume: 50,
              autoplay: true,
              muted: false,
              fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: true,
                container: null,
              },
              youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
              },
              controls: [
                "play-large",
                "play",
                "progress",
                "current-time",
                "mute",
                "volume",
                "captions",
                "settings",
                "pip",
                "airplay",
                "fullscreen",
              ],
            }
          )
      );

      // const script = document.createElement('script');

      // script.src = "https://cdn.plyr.io/1.8.2/plyr.js";
      // script.src = "https://cdn.jsdelivr.net/hls.js/latest/hls.js";
      // script.async = true;

      // document.body.appendChild(script);

      // return () => {
      //     document.body.removeChild(script);
      // }

      // var video = document.querySelector('#player');

      // if (Hls.isSupported()) {
      //   var hls = new Hls();
      //   hls.loadSource('https://content.jwplatform.com/manifests/vM7nH0Kl.m3u8');
      //   hls.attachMedia(video);
      //   hls.on(Hls.Events.MANIFEST_PARSED,function() {
      //     video.play();
      //   });
      // }

      // plyr.setup(video);
    }
  }, [data, isAutoplay]);

  return (
    <div className="w-auto h-100">
      {isMux ? (
        /* eslint-disable jsx-a11y/media-has-caption */
        <video
          src={`https://stream.mux.com/${getVideoSrcProvider(data).src}.m3u8`}
          width="100%"
          height="100%"
          crossorigin
          id="player"
          controls
        />
      ) : isLoom ? (
        <div
          style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
        >
          <iframe
            src={`https://www.loom.com/embed/${data.loomId}`}
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen={true}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title={data.title}
          />
        </div>
      ) : (
        <div
          className="js-player"
          data-plyr-provider={getVideoSrcProvider(data).provider}
          data-plyr-embed-id={getVideoSrcProvider(data).src}
        />
      )}
    </div>
  );
}